import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { ImageEditorComponent } from '../image-editor/image-editor.component';

@Component({
  selector: 'app-t-new-image-compression',
  templateUrl: './t-new-image-compression.component.html',
  styleUrls: ['./t-new-image-compression.component.css']
})
export class TNewImageCompressionComponent extends GeneralTeacherComponent {
  @ViewChild('imageEditor', {static: true}) imageEditor: ImageEditorComponent;

  image: string[][];
  highlight: boolean = false;
  colors: string = "bw";

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute) {
    super(topicService, activatedRoute)
    this.title = this.get("newImageCompression");
    this.type = "newImageCompression";
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.image = this.configuration.typespecifics.image;
    if(this.image.map(v => v.join("")).join("").includes("w")){
      this.colors = "bw";
    } else {
      this.colors = "cmyrgb"
    }
    this.highlight = this.configuration.typespecifics.highlight;
    this.imageEditor.setImage(this.image);
    if (this.image) {
      this.imageEditor.setImage(this.image);
    }
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/newImageCompression.png";
    definition.level = 3;
    definition.key = "compression%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.image = this.imageEditor.getImage();
    definition.typespecifics.highlight = this.highlight;
    this.image = this.imageEditor.getImage();
    definition.key = definition.key.concat("%", this.image.toString());
  return definition;
  }

  generate() {
    this.colors = Math.random() > 0.5 ? "bw": "cmyrgb";
    this.imageEditor.colors = this.colors;
    this.highlight = Math.random() > 0.5;
    this.image = this.imageEditor.possibleImages[Math.floor(Math.random()*this.imageEditor.possibleImages.length)];
    this.imageEditor.setImage(this.image);
  }

  reset(){
    super.reset();
    this.title  =this.get("newImageCompression");
    this.colors = "bw";
    this.highlight = true;
    this.imageEditor.initImage();
  }

}
